import { createUpsGhostAccountLocationSchema } from "@redotech/redo-fulfillment-carrier-account-common/ups-ghost-account-location";
import * as z from "zod";

export const upsGhostAccountLocation =
  createUpsGhostAccountLocationSchema.extend({
    id: z.string(),
    ghostAccountNumber: z.string(),
  });

export type UpsGhostAccountLocation = z.infer<typeof upsGhostAccountLocation>;

export const getUpsGhostAccountIntegration = {
  name: "getUpsGhostAccountIntegration" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(upsGhostAccountLocation) }),
};
